import { render, staticRenderFns } from "./help-dialog.vue?vue&type=template&id=491e6e7c&scoped=true&"
import script from "./help-dialog.vue?vue&type=script&lang=js&"
export * from "./help-dialog.vue?vue&type=script&lang=js&"
import style0 from "./help-dialog.vue?vue&type=style&index=0&id=491e6e7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491e6e7c",
  null
  
)

export default component.exports